import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const DEFAULT_COLUMN_OPTIONS = [
  { label: 'SubmissionID', value: 's.Id' },
  { label: 'HH-ID', value: 'p.HHId' },
  { label: 'ReportingPeriod', value: 's.ReportingPeriod' }
];

const conditionOptions = [
  { label: 'Equals', value: 'equals' },
  { label: 'Contains', value: 'contains' }
];

// columnOptions: optional array of { label, value } — falls back to DEFAULT_COLUMN_OPTIONS
// dropdownValueOptions: optional map of columnValue → [{ value, label }] for dynamic select inputs
function FilterPanel({ filters, setFilters, columnOptions: customColumnOptions, dropdownValueOptions = {} }) {
  const columnOptions = customColumnOptions || DEFAULT_COLUMN_OPTIONS;

  const [newFilter, setNewFilter] = useState({
    column: columnOptions[0]?.value || 'p.HHId',
    condition: 'equals',
    value: ''
  });

  const isDynamicDropdown = Boolean(dropdownValueOptions[newFilter.column]?.length);

  const handleColumnChange = (colValue) => {
    setNewFilter({ column: colValue, condition: 'equals', value: '' });
  };

  const addFilter = () => {
    if (newFilter.value.trim()) {
      setFilters([...filters, newFilter]);
      setNewFilter({ column: newFilter.column, condition: 'equals', value: '' });
    }
  };

  const removeFilter = (index) => {
    const updated = [...filters];
    updated.splice(index, 1);
    setFilters(updated);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
        <select
          value={newFilter.column}
          onChange={e => handleColumnChange(e.target.value)}
        >
          {columnOptions.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        {/* Only show condition selector for free-text columns */}
        {!isDynamicDropdown && (
          <select
            value={newFilter.condition}
            onChange={e => setNewFilter({ ...newFilter, condition: e.target.value })}
          >
            {conditionOptions.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        )}

        {/* Dynamic dropdown vs free-text input */}
        {isDynamicDropdown ? (
          <select
            value={newFilter.value}
            onChange={e => setNewFilter({ ...newFilter, value: e.target.value })}
            style={{ minWidth: '160px' }}
          >
            <option value="">-- Select --</option>
            {dropdownValueOptions[newFilter.column].map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            type="text"
            value={newFilter.value}
            onChange={e => setNewFilter({ ...newFilter, value: e.target.value })}
            placeholder="Value"
          />
        )}

        <button className='btn btn-primary btn-sm me-2' onClick={addFilter}>Add</button>
      </div>

      {filters.map((filter, index) => {
        const columnLabel = columnOptions.find(opt => opt.value === filter.column)?.label || filter.column;
        const conditionLabel = conditionOptions.find(opt => opt.value === filter.condition)?.label || filter.condition;
        const valueLabel = dropdownValueOptions[filter.column]?.find(o => o.value === filter.value)?.label || filter.value;

        return (
          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', border: '1px solid #ccc', padding: '0.25rem 0.5rem', borderRadius: '4px' }}>
            <span>{columnLabel} {conditionLabel} {valueLabel}</span>
            <button className='btn btn-primary btn-sm me-2' onClick={() => removeFilter(index)} style={{ marginLeft: '0.25rem' }}>✕</button>
          </div>
        );
      })}
    </div>
  );
}

export default FilterPanel;
